import React from 'react';

export class FireForceJacket extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="fireforcejacket">
          <h1>Fire Force WiFi Jacket</h1>
          <p>I wore a more complicated jacket to EDC, much too bulky for the actual event. Should have kept it more towards SuperCon or Teardown conference.</p>


          <img src="../../assets/fireForceJacket1.jpg" alt="Woman wearing black jacket with colorful glowing bands around arms and chest."></img>
          <img src="../../assets/fireForceJacketBecky.jpg" alt="Woman pointing at a phone with colors and a sketch of a jacket."></img>
        </div>
    );
  }
}
